import { SettingCache } from "services/KnowfullyAdminClient";
import { SettingTypeId } from "types/common-types";
import SettingValue from "./SettingValue";
import ResponsiveIframe from "components/ResponsiveIframe";
import { Box } from "@mui/material";

const styles = {
  htmlSettingWrapper: {
    maxHeight: "250px",
    overflowX: "hidden",
    overflowY: "auto",
  },
};

type SettingValuePreviewProps = {
  value: SettingCache;
};

export default function SettingValuePreview({
  value,
}: SettingValuePreviewProps) {
  if (value.settingTypeId === SettingTypeId.Html) {
    return (
      <Box sx={styles.htmlSettingWrapper}>
        <ResponsiveIframe srcDoc={value.value ?? ""} title="htmlPreview" />
      </Box>
    );
  }

  return <SettingValue value={value} />;
}
